<template>
  <div class="million-read-book-list-item">
    <div v-if="showManage"
         class="million-read-book-list-item-action"
         @click="handleManageBook(item.id)"
    >
      <ym-img v-if="selected"
              class="icon"
              :src="require('@/assets/img/million_read/mr_favorite_remove_icon.png')"
      />
      <ym-img v-else
              class="icon"
              :src="require('@/assets/img/million_read/mr_favorite_icon.png')"
      />
    </div>
    <div class="million-read-book-list-item-container"
         @click="handleToBookDetail(item.type, item.id)"
    >
      <book-cover :cover="item.cover"
                  :book-type="item.type"
                  :progress="item.progress"
                  :type="type"
      />
      <div class="million-read-book-list-item-info">
        <div class="million-read-book-list-item-title ym-two-line-ellipsis"
             :class="`type-${type}`"
        >
          {{ item.title }}
        </div>
        <div class="million-read-book-list-item-summary ym-two-line-ellipsis">
          {{ item.summary }}
        </div>
        <div class="million-read-book-list-item-tag-list">
          <div class="million-read-book-list-item-tag"
               v-for="(tag, tagIndex) in item.tag"
               :key="tagIndex"
          >
            {{ tag }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BookCover from '@/pages/MillionRead/components/BookCover';
  import { getProductPath, locationPath } from '@/utils';

  export default {
    name: 'MillionReadBookListItem',
    components: {
      BookCover,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      showManage: {
        type: Boolean,
        default: false,
      },
      selectAll: {
        type: Boolean,
      },
      type: {
        type: String,
        default: 'small',
        validator(val) {
          return [
            'extra-small',
            'small',
            'normal',
          ].includes(val);
        },
      },
    },
    data() {
      return {
        selected: false,
      };
    },
    watch: {
      selectAll(val) {
        this.selected = val;
      },
    },
    methods: {
      handleManageBook(id) {
        this.selected = !this.selected;
        this.$emit('select-book', id);
      },
      handleToBookDetail(type, id) {
        locationPath(getProductPath(type, id));
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-book-list-item {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;

    &-action {
      flex-shrink: 0;
      width: 36px;
      height: 36px;
      margin-right: 24px;
      .icon {
        display: block;
        width: 36px;
        height: 36px;
      }
    }

    &-container {
      flex: 1;
      display: flex;
      align-items: center;
    }

    &-info {
      flex: 1;
      margin-left: 24px;
    }
    &-title {
      margin-bottom: 16px;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      line-height: 1.5;
      &.type-extra-small {
        font-size: @font-size-base;
      }
    }
    &-summary {
      color: @color-text-lighter;
      font-size: @font-size-small;
      line-height: 1.2;
    }
    &-tag-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &-tag {
      box-sizing: border-box;
      flex-shrink: 0;
      margin-right: 14px;
      margin-top: 14px;
      padding: @size-extra-small @size-small;
      color: @color-text-light;
      font-size: @font-size-extra-small;
      background: #f5f6f7;
      border-radius: 20px;
    }
  }

</style>
